import { GifOverlayProps } from '@giphy/js-components/dist/components/gif'
import { VideoPreviewLabel } from '@giphy/react-giphy-brand'
import { IGif } from '@giphy/js-types'
import { Gif } from '@giphy/react-components'
import React, { useCallback } from 'react'
import { useHistory } from 'react-router'
import styled, { css, keyframes } from 'styled-components'
import Video from './video'
import Volume from './volume'
import { parseUrl } from 'shared/util/url'
export const ASPECT_RATIO = 16 / 9

const EnterOverlay = keyframes`
    0% { 
        filter: brightness(100%);
    }
    100% { 
        filter: brightness(50%);
    }
`

const LeaveOverlay = keyframes`
    0% {
        filter: brightness(50%);
    }
    100% {
        filter: brightness(100%);
    }
`

const PreviewContainer = styled.div<{ withOverlay?: boolean; width?: number; height?: number }>`
    position: relative;
    width: ${props => `${props.width}px` || 'auto'};
    height: ${props => `${props.height}px` || 'auto'};
    display: flex;
    ${props =>
        props.withOverlay
            ? css`
                  filter: brightness(50%);
                  animation: 0.4s ${EnterOverlay} ease-in-out;
              `
            : css`
                  animation: 0.4s ${LeaveOverlay} ease-in-out;
              `}
`

const StyledPreviewLabel = styled(VideoPreviewLabel)`
    margin-left: auto;
    margin-right: auto;

    h3 {
        font-size: 14px;
    }
`

type Props = {
    gif: IGif
    width: number
    height?: number
    withOverlay?: boolean
    className?: string
    showClipTitle?: boolean
    playOnHover?: boolean
    volumeSize?: number
}

const VideoPlayOnHover = ({
    gif,
    width,
    height,
    className = '',
    withOverlay = false,
    showClipTitle = false,
    playOnHover = true,
    volumeSize = 38,
}: Props) => {
    const previewHeight = height || width / ASPECT_RATIO
    const history = useHistory()
    const overlay = useCallback(
        (props: GifOverlayProps) => <Video {...props} width={width} volumeSize={volumeSize} />,
        [gif.id]
    )
    const overlayWithoutAutoPlay = useCallback(() => <Volume muted isHovered={false} volumeSize={volumeSize} />, [])
    const { title, user } = gif
    const { pathname } = parseUrl(gif.url)

    return (
        <div className={className}>
            <PreviewContainer withOverlay={withOverlay}>
                <Gif
                    gif={gif}
                    width={width}
                    height={previewHeight}
                    overlay={playOnHover ? overlay : overlayWithoutAutoPlay}
                />
            </PreviewContainer>
            {showClipTitle && (
                <StyledPreviewLabel
                    href={gif.url}
                    onClick={() => history.push(String(pathname))}
                    showAttribution={false}
                    title={title}
                    user={user}
                    width={width}
                />
            )}
        </div>
    )
}

export default VideoPlayOnHover
